import { useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useMenu } from './useMenu'
import {
  coletarAncestraisMenuPorRota,
  rotaEhRaizOuDashboard,
} from '../componentesCompartilhados/layout/menuAncestorUtils'

const STORAGE_KEY = 'zeus.sidebar.somenteRailSubmenu'

function lerPreferenciaSomenteRail(): boolean {
  if (typeof window === 'undefined')
    return false
  return localStorage.getItem(STORAGE_KEY) === '1'
}

function persistSomenteRailSubmenu(ativo: boolean) {
  localStorage.setItem(STORAGE_KEY, ativo ? '1' : '0')
}

export function useSomenteRailSubmenuPreferencia(): [boolean, (ativo: boolean) => void] {
  const [ativo, setAtivo] = useState(lerPreferenciaSomenteRail)

  const definir = useCallback((next: boolean) => {
    setAtivo(next)
    persistSomenteRailSubmenu(next)
  }, [])

  return [ativo, definir]
}

/** Desktop (≥lg): preferência ligada e rota permite modo rail (filha no menu OU `/`/`/dashboard`). */
export function useSomenteRailSubmenuDesktopAtivo(preferenciaSomenteRail: boolean): boolean {
  const { menuItems } = useMenu()
  const { pathname } = useLocation()
  const [lg, setLg] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(min-width: 1024px)').matches : false,
  )

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 1024px)')
    const alt = () => setLg(mq.matches)
    alt()
    mq.addEventListener('change', alt)
    return () => mq.removeEventListener('change', alt)
  }, [])

  const ancestrais = useMemo(() => coletarAncestraisMenuPorRota(menuItems, pathname) ?? [], [menuItems, pathname])

  const permiteRailSomentePorSubmenu =
    ancestrais.length > 0 || rotaEhRaizOuDashboard(pathname)

  return preferenciaSomenteRail && lg && permiteRailSomentePorSubmenu
}
